<template>
<div id="app">
  <global-header/>
  <div class="wrap">
    <div class="main">
			<ul class="breadcrumb">
        <li v-for="crumb in breadcrumbs" :key="crumb.name">
          <div v-if="!crumb.active">
            <router-link :to="crumb.path" class="breadcrumb__link--inactive">{{crumb.name}}</router-link>&nbsp;&gt;&nbsp;
          </div>
          <div v-else><a class="breadcrumb__link--active">{{crumb.name}}</a></div>
        </li>
        <!--
        <div v-for="crumb in breadcrumbs" :key="crumb.name">
          <li v-if="!crumb.active"><router-link :to="crumb.path" class="breadcrumb__link--inactive">{{crumb.name}}</router-link>&nbsp;/&nbsp;</li>
          <li v-else>{{crumb.name}}</li>
        </div>
        -->
			</ul>
      <part-header/>
      <section class="section-catalog">
				<nav class="sub-nav">
          <item-search/>
          <router-view name="side" :categorySet="sortCategories"/>
        </nav>
				<div class="main-content">
          <router-view name="mainview" :categorySet="sortCategories"/>
        </div>
      </section>
    </div>
  </div>
  <global-footer/>
</div>
</template>

<script>
  import PartHeader from '@/components/PartHeader';
  import ItemSearch from '@/components/ItemSearch';
  import GlobalHeader from '@/components/GlobalHeader';
  import GlobalFooter from '@/components/GlobalFooter';

  export default {
    name: 'App',
    components: {
      PartHeader,
      ItemSearch,
      GlobalHeader,
      GlobalFooter
    },
    data: function () {
      return {
        siteName: "チガサキレンタル株式会社",
        defaultTitle: "商品カタログ",
        title: "商品カタログ | チガサキレンタル株式会社",
        description: "建設機械レンタルのチガサキレンタル株式会社です。当社で取り扱いのある商品のカタログを掲載しています。各種性能表が掲載されており、カタログPDFファイルをダウンロードすることもできます。機種一覧からカテゴリごとに分類された商品を選択することもできますし、フリーワード検索にも対応しております。",
        keywords: "建設機械,土木機械,掘削機,バックホー,油圧ショベル,レンタカー,道路機械,解体,林業,アタッチメント,高所作業車,整地,運搬機械",
        categories: [],
        breadcrumbs: [{
          name: 'HOME',
          path: '',
          active: true
        }],
        category_id: null,
        active_page_title: null,
        lastPageViewKey: ''
      }
    },
    mounted : function () {
      //meta
      this.applyHead()
      if (this.$route && this.$route.path === '/') {
        this.sendPageView()
      }
      //categories
      var url = process.env.VUE_APP_URL + '/categories/search'
      var myToken = process.env.VUE_APP_TOKEN
      var myComId = process.env.VUE_APP_COMPANY_ID
      var params = {'limit': 1000, 'company_id': myComId}
      var myHeaders = {'Content-Type': 'application/json', 'Authorization': `Token ${myToken}` }
      fetch(url, {
        method: "POST",
        mode: "cors",
        headers : myHeaders,
        body: JSON.stringify(params)
      })
      .then(res => {
        return res.json()
      })
      .then(data => {
        this.categories = data
        this.updateBreadcrumbsFromRoute()
      })
      .catch(e => console.error(e))
    },
    created: function () {
    },
    methods : {
      resetBreadcrumbs: function () {
        this.breadcrumbs = [{
          name: 'HOME',
          path: '/',
          active: true
        }]
      },
      updateBreadcrumbsFromRoute: function () {
        var routeName = this.$route && this.$route.name
        if (!this.sortCategories.length) {
          this.resetBreadcrumbs()
          return
        }
        if (routeName === 'list') {
          this.setBreadcrumbs(Number(this.$route.params.Id))
          return
        }
        if (routeName === 'speclist' || routeName === 'speclist2') {
          var specName = this.$route.params.Spec || ''
          var matched = this.sortCategories.filter(function (item) {
            return item.name.indexOf(specName) >= 0
          })
          if (matched.length) {
            this.breadcrumbs = [
              {
                name: 'HOME',
                path: '/',
                active: false
              },
              {
                name: matched[0].name,
                path: '/speclist/' + matched[0].name,
                active: true
              }
            ]
            return
          }
        }
        if (routeName === 'search') {
          var keyword = this.$route.params.Keyword || ''
          this.breadcrumbs = [
            {
              name: 'HOME',
              path: '/',
              active: false
            },
            {
              name: '検索: ' + keyword,
              path: '',
              active: true
            }
          ]
          return
        }
        this.resetBreadcrumbs()
      },
      applyHead: function () {
        document.title = this.title
        var metaPairs = [
          { name: 'description', content: this.description },
          { name: 'keywords', content: this.keywords }
        ]
        metaPairs.forEach(function (item) {
          var meta = document.querySelector('meta[name="' + item.name + '"]')
          if (!meta) {
            meta = document.createElement('meta')
            meta.setAttribute('name', item.name)
            document.head.appendChild(meta)
          }
          meta.setAttribute('content', item.content)
        })
      },
      formatPageTitle: function (title) {
        var pageTitle = title || this.defaultTitle
        if (pageTitle === this.siteName) return pageTitle
        return pageTitle + ' | ' + this.siteName
      },
      setPageMeta: function (title, description, keywords) {
        if (title !== undefined) this.title = this.formatPageTitle(title)
        if (description !== undefined) this.description = description
        if (keywords !== undefined) this.keywords = keywords
        this.applyHead()
        this.sendPageView()
      },
      sendPageView: function () {
        if (!this.$gtag || !this.$gtag.pageview || typeof window === 'undefined') {
          return
        }
        var pagePath = this.$route ? this.$route.fullPath : window.location.pathname
        var pageViewKey = pagePath + '|' + this.title
        if (pageViewKey === this.lastPageViewKey) {
          return
        }
        this.lastPageViewKey = pageViewKey
        this.$gtag.pageview({
          page_title: this.title,
          page_path: pagePath,
          page_location: window.location.href
        })
      },
      setBreadcrumbs: function (id) {
        var matched = false
        this.resetBreadcrumbs()
        for(var i=0; i<this.sortCategories.length; i++){
          if(this.sortCategories[i].id == id){
            this.breadcrumbs = [
              {
                name: 'HOME',
                path: '/',
                active: false
              },
              {
                name: this.sortCategories[i].name,
                path: '/speclist/' + this.sortCategories[i].name,
                active: true
              }
            ]
            matched = true
            break
          }
          for(var j=0; j<this.sortCategories[i].child.length; j++){
            if(this.sortCategories[i].child[j].id == id){
              this.breadcrumbs = [
                {
                  name: 'HOME',
                  path: '/',
                  active: false
                },
                {
                  name: this.sortCategories[i].name,
                  path: '/speclist/' + this.sortCategories[i].name,
                  active: false
                },
                {
                  name: this.sortCategories[i].child[j].name,
                  path: '',
                  active: true
                },
              ]
              matched = true
              break
            }
            for(var k=0; k<this.sortCategories[i].child[j].child.length; k++){
              if(this.sortCategories[i].child[j].child[k].id == id){
                this.breadcrumbs = [
                  {
                    name: 'HOME',
                    path: '/',
                    active: false
                  },
                  {
                    name: this.sortCategories[i].name,
                    path: '/speclist/' + this.sortCategories[i].name,
                    active: false
                  },
                  {
                    name: this.sortCategories[i].child[j].child[k].name,
                    path: '/list/' + this.sortCategories[i].child[j].child[k].id,
                    active: false
                  },
                  {
                    name: this.active_page_title,
                    path: '',
                    active: true
                  },
                ]
                matched = true
                break
              }   
            }
          }
        }
        if(!matched){
          this.resetBreadcrumbs()
        }
      }
    },
    computed: {
      sortCategories: function() {
        var cat = this.categories
        // id順にソート（読み込み順を守るため）
        cat.sort(function(a,b){
          let r = 0
          if(a['id'] < b['id']){r=-1}
          else if(a['id'] > b['id']){r=1}
          return r
        })

        var cat2h = {}; // idをキーにしたhash
        var mother_key = 0;
        for(var i=0;i<cat.length;i++){
          cat[i].show = false;
          cat[i].child = [];
          cat2h[cat[i].id] = cat[i];
        }
        for(i=0;i<cat.length;i++){
          mother_key = cat[i].category_id;
          if(mother_key){
            cat2h[mother_key].child.push(cat[i]);
          }
        }
        var catout = []
        for(var key in cat2h){
          if(!cat2h[key].category_id){
            catout.push(cat2h[key]);
          }
        }
        return catout;
      }
    },
    watch: {
      'title': function (){
        this.applyHead()
      },
      'description': function () {
        this.applyHead()
      },
      'keywords': function () {
        this.applyHead()
      },
      'category_id': function () {
        this.setBreadcrumbs(this.category_id)
      },
      'active_page_title': function () {
        this.setBreadcrumbs(this.category_id)
      },
      'categories': function () {
        this.setBreadcrumbs(this.category_id)
      },
      '$route': function () {
        this.updateBreadcrumbsFromRoute()
      }
    }
  }
</script>
